









import Vue from 'vue'
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";

export default Vue.extend({
  name: 'Button',
  components: {
    SfButton
},
  props: {
    properties: {
      type: Object
    },
    classStyle: {
      type: [String, Object]
    },
    type: {
      type: [String, Object],
    },
    link: {
      type: [String, Object],
    },
    ariaLabel: {
      type: String,
      default: "button",
    },
    disabled: {
      type: [Boolean, Object], // type: Boolean,
      default: false,
    },
  },
})
